import React, { Component } from "react";
import { connect } from "react-redux";
import { showInfoModal } from "../../redux/actions/miscActions";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import { Table } from "antd";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "../MyDocument";

dayjs.locale("nl");

export class EmTable extends Component {
  handleshow = (text, record) => {
    this.props.showInfoModal("loonslip", record);
  };

  render() {
    const { companyInformation, uploadedImage } = this.props.formData;
    const columns = [
      {
        title: "Personeel nummer",
        key: "pers_nummer",
        render: (text, record) => text.employee.personeelsNummer,
      },
      {
        title: "Naam",
        key: "naam",
        render: (text, record) => text.employee.naam,
      },
      {
        title: "ID Nummer",
        key: "id_nummer",
        render: (text, record) => text.employee.idNummer,
      },
      {
        title: "download",
        key: "download",
        render: (text, record) => (
          <PDFDownloadLink
            document={
              <MyDocument
                data={record}
                comp={companyInformation}
                {...this.state}
              />
            }
            fileName={text.employee.naam}
          >
            download
          </PDFDownloadLink>
        ),
      },
      // {
      //   title: "download",
      //   key: "download",
      //   render: (text, record) => (
      //     <PDFDownloadLink
      //       document={
      //         <MyDocument
      //           data={record}
      //           comp={companyInformation}
      //           {...this.state}
      //           img={newImage}
      //         />
      //       }
      //       fileName={text.employee.naam}
      //     >
      //       {/* {({ blob, url, loading, error }) =>
      //         loading ? "Loading..." : "Download"
      //       } */}
      //       download
      //     </PDFDownloadLink>
      //   ),
      // },
    ];
    return (
      <div className="employee-table-container">
        <Table
          className="employee-table"
          columns={columns}
          pagination={{ pageSize: 12 }}
          locale={{ ...this.props }}
          {...this.props}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
});

export default connect(mapStateToProps, { showInfoModal })(EmTable);
